const UserSearch = (state = '', action) => {
  switch (action.type) {
    case 'FILTER_USER':
      return action.payload
    default:
      return state
  }
}

export default UserSearch
